import React from 'react';

export const SkeletonLoader = ({ style }) => {
    return (
        <span class="skeleton-loader" style={style}></span>
    );
};

export default SkeletonLoader;